import React from 'react';

import {Box, BoxProps} from 'src/components/shared';
import styled from 'styled-components/macro';

export type FireworkContainerProps = BoxProps & {containerMaxWidth: string};

export const FireworkContainer: React.FC<FireworkContainerProps> = styled(Box)``;
